import { AccountLanguageSelector } from "@pages/account-settings/sections/account-language-selector";
import { AccountUnitSelector } from "@pages/account-settings/sections/account-unit-selector";
import { ThemeModeToggle } from "@components/common/theme-mode-toggle";
/** Content for the preferences tab of account settings page */
export function accountSettingsPreferencesTab({
  isBetaTestingEnabled
}) {
  return [{
    title: "Language",
    subtitle: "Changes to your language will be reflected across Sphere XG applications.",
    items: [{
      label: "Language",
      shouldHidePaddingY: true,
      content: <AccountLanguageSelector />
    }]
  }, {
    title: "Units",
    subtitle: `Select your preferred units of measurement. The chosen unit
        will be used consistently across reports, charts, and project metrics.`,
    items: [{
      label: "Units",
      shouldHidePaddingY: true,
      content: <AccountUnitSelector />,
      shouldHideTopBorder: true
    }]
  },
  // TODO: Remove this https://faro01.atlassian.net/browse/ST-4789
  {
    title: "Themes",
    subtitle: `Select your preferred theme. The chosen theme
        will be applied across the application.`,
    isHidden: !isBetaTestingEnabled,
    items: [{
      label: "Theme Mode",
      shouldHidePaddingY: true,
      content: <ThemeModeToggle />,
      shouldHideTopBorder: true
    }]
  }];
}